// extracted by mini-css-extract-plugin
export default {"buttons":"NewApplicationForm_buttons__tlgBD"};